
  import { Component, Vue } from 'vue-property-decorator'
  import { testRoutes } from '@/router'
  
  @Component
  export default class TestHome extends Vue {
    get routePaths() {
      const routes = testRoutes.navRoutes;
      return routes;
    }
  }
